import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import { Form, Input, Switch } from 'antd';
import {
    accountDocumentAllowedMimeTypes
} from '../../../../common/enums';
import DocumentList from '../../../documents/components/DocumentList';
import { selectToken, selectAccountId } from '../../../../features/auth/ducks';
import { connect } from 'react-redux';
import {
    selectDocumentsVersion,
    updateAccountDocumentsActions,
    submitAccountDocumentsActions,
    uploadFileAndUpdateAccountDocumentsActions,
} from '../../../../features/documents/ducks';
import { selectIsInProgress } from '../../../../features/spinner/ducks';
import { apiCallIds as accountManagementApiCallIds } from '../../../../features/account-management/api';
import { apiCallIds as filesApiCallIds } from '../../../../features/files/api';
import { removeUploadedFileAction, resetUploadedFilesAction } from '../../../../features/files/ducks';

const FormItem = Form.Item;

const mapStateToProps = state => ({
    token: selectToken(state),
    documentsVersion: selectDocumentsVersion(state),
    isUpdating: selectIsInProgress(state, accountManagementApiCallIds.UPDATE_ACCOUNT_DOCUMENTS),
    isUploading: selectIsInProgress(state, filesApiCallIds.UPLOAD_FILE),
    accountId: selectAccountId(state),
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            removeUploadedFile: removeUploadedFileAction,
            resetUploadedFiles: resetUploadedFilesAction,
            submitAccountDocuments: submitAccountDocumentsActions.request,
            updateAccountDocuments: updateAccountDocumentsActions.request,
            uploadFileAndUpdateAccountDocuments: uploadFileAndUpdateAccountDocumentsActions,
        },
        dispatch
    ),
});

const createDocumentUploadType = documentType => `dashboardDocuments/${documentType}`;

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class IdentityCardCheckForm extends Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
        profileData: PropTypes.object.isRequired,
        documents: PropTypes.array.isRequired,
    }

    state = {
        hasSameID: true,
        newID: '',
    }

    onUpload = uploadingDocument => uploadData => {
        const { documentsVersion, accountId, actions, allDocuments } = this.props;

        const formData = new FormData();
        formData.append('dataFile', uploadData.file);

        const documentType = uploadingDocument.documentType;
        const documentUploadType = createDocumentUploadType(documentType);
        const filteredDocuments = [...allDocuments]

        const documentUploadTypes = [
            ...filteredDocuments.map(doc => createDocumentUploadType(doc.type)),
            documentUploadType,
        ];

        actions.uploadFileAndUpdateAccountDocuments({
            uploadFilePayload: {
                uploadedFilesId: documentUploadType,
                formData: formData,
                single: true,
            },
            fileType: documentType,
            updateAccountDocumentsPayload: {
                accountId: accountId,
                uploadedFilesId: documentUploadTypes,
                documentsData: {
                    documents: filteredDocuments.map(document => ({
                    file: {
                        id: document.file.id,
                        name: document.file.name,
                    },
                        type: document.type,
                    })),
                    version: documentsVersion,
                },
            },
        });
    };

    onRemove = doc => file => {
        this.props.actions.removeUploadedFile({
            uploadedFilesId: doc.documentUploadType,
            fileId: file.uid,
        });

        return true;
      };

    render () {
        const { form, t, profileData, token, isUpdating, isUploading } = this.props;
        const uploadingAvailable = true;

        return (
            <div>
                <Row style={{
                    marginTop: 30,
                    borderRadius: 5,
                    backgroundColor: '#ffe4c4'
                }}>
                    <Col md={10} style={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '1.4rem'
                    }}>
                        {t("Číslo vášho občianskeho preukazu sa zhoduje s číslom zadaným pri registrácii: ")} 
                        <strong>&nbsp;{profileData.idCardNumber}</strong>
                    </Col>
                    <Col md={2}>
                        <FormItem>
                        {
                            form.getFieldDecorator('hasSameID', {
                                initialValue: true,
                                valuePropName: 'checked',
                            }) (
                                <Switch
                                    name={'hasSameID'}
                                    size={'default'}
                                    checkedChildren={t('áno')}
                                    unCheckedChildren={t('nie')}
                                    onChange={ e => this.setState({ hasSameID: e })}
                                />
                            )
                        }
                        </FormItem>
                    </Col>
                </Row>
                {
                    !this.state.hasSameID ? (
                    <div>
                        <Row>
                            <Col md={12}>
                                <FormItem label={t('Zadajte nové číslo občianskeho preukazu')}>
                                    {
                                        form.getFieldDecorator('idCardNumber', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: t('Povinné pole'),
                                                },
                                            ],
                                        }) (
                                            <Input
                                                name={'idCardNumber'}
                                                placeholder={t('Číslo občianskeho preukazu')}
                                                maxLength={'8'}
                                            />
                                        )
                                    }
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <DocumentList
                                    allowedMimeTypes={accountDocumentAllowedMimeTypes}
                                    documents={this.props.documents}
                                    loading={isUpdating || isUploading}
                                    onOptionalDocumentChange={() => {}}
                                    onRemove={this.onRemove}
                                    onUpload={this.onUpload}
                                    token={token}
                                    uploadingAvailable={uploadingAvailable}
                                />
                            </Col>
                        </Row>
                    </div>
                ) : null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/IdentityCardCheckForm.js